import React from 'react';
import Modal from '../../components/ui/Modal';

const EditClientModal = ({
  showEditModal,
  setShowEditModal,
  editFormData,
  setEditFormData,
  handleEditSubmit,
}) => (
  <Modal
    show={showEditModal}
    onClose={() => setShowEditModal(false)}
    title="Edit Client"
    size="md"
    footer={
      <>
        <button type="button" onClick={() => setShowEditModal(false)} className="btn-ghost">
          Cancel
        </button>
        <button type="submit" form="edit-client-form" className="btn-premium px-5 py-2 text-sm">
          Save Changes
        </button>
      </>
    }
  >
    <form id="edit-client-form" onSubmit={handleEditSubmit} className="space-y-4">
      <div>
        <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
          Name
        </label>
        <input
          type="text"
          className="input-modern"
          value={editFormData.name}
          onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
          required
        />
      </div>
      <div>
        <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">
          Email
        </label>
        <input
          type="email"
          className="input-modern"
          value={editFormData.email}
          onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
          required
        />
      </div>
    </form>
  </Modal>
);

export default EditClientModal;
